// Route wrapper for the Integrations screen: binds which card's remove
// confirmation is open to the URL (?confirmRemove={name}).
//
// Only the confirmation is routed. The credential input is write-only and stays
// in component state — a fleet secret must never enter the address bar.
import { useNavigate, useSearch } from '@tanstack/react-router';
import { IntegrationsScreen } from './IntegrationsScreen';

export function IntegrationsRoute() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { confirmRemove?: string };
  return (
    <IntegrationsScreen
      confirmRemove={search.confirmRemove ?? null}
      onConfirmRemoveChange={(name) =>
        void navigate({ to: '/integrations', search: name ? { confirmRemove: name } : {} })
      }
    />
  );
}
